import * as classNames from 'classnames';
import { DataService } from '../../../services/data_service';
import { filterBundleForForm } from '../functions/filterBundle';
import { fn2nZ } from '../../../core/formatter/formatNumber';
import { formStyle, WFormData } from '../../../core/forms/WFormFramework';
import { i18n } from '../../../i18n/i18n';
import { IDs } from '../../../helpers/IDs';
import { isValid as isValidData } from '../../../main/functions/validData';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { removeErrorLevelAddOn } from '../../../core/forms/helpers/errorLevelTools';
import { renderText } from '../../../bereiche/dateneingabe/assistent/assistent_helpers';
import { StructureTool } from '../../../core/forms/helpers/structure_tool';
import style from './DialogCO2Entfernung.less';
import { validateFieldUniversal } from '../functions/validateField';
import { WActionButton } from '../../../core/elements/WActionButton';
import { WHelpIcon } from '../../../core/elements/WHelpIcon';
import { WSpinner } from '../../../core/elements/spinner/WSpinner';

export interface DialogCO2EntfernungMobiProps {
    data: any;
    entity: any;
    standortSelected: any;
    jahr: any;
    values: any;
    onChange: (entityName: string, formValues: any) => void;
    onClose: () => void;
    reloadData: (entityName: string) => void;
}

export interface DialogCO2EntfernungMobiState {
    data: any;
    showSpinner: boolean;
}

export class DialogCO2EntfernungMobi extends React.Component<DialogCO2EntfernungMobiProps, DialogCO2EntfernungMobiState> {

    constructor(props: any) {
        super(props);
        this.state = {
            data: null,
            showSpinner: false
        };
        this.onChange = this.onChange.bind(this);
        this.saveData = this.saveData.bind(this);
    }

    @lazyInject(DataService) private dataService: DataService;

    private entity: string = (this.props.entity || {}).entity || null;
    private FormData: any = new WFormData();
    private sumEntfernung: number;

    componentDidMount(): void {
        const row: any = this.props.values || {};
        const entityData: Array<any> = this.props.data[this.entity] || [];
        const data: any = {};
        entityData.filter((r: any) => r.parent_tid === (row.tid || 0) && r.modus === row.modus && (!r.art || r.art === row.art))
            .forEach((r: any, index: number) => data[index] = r);
        const kraftstoff_distance = this.getKraftstoff();
        const transportmittel_mobilitaet = this.getTransportmittel();
        this.FormData.setBundle({ ...(this.props.data[`${this.entity}_bundle`] || {}), kraftstoff_distance, transportmittel_mobilitaet });
        this.setState({ data });
    }

    getKraftstoff() {
        const structure: any = new StructureTool(IDs.MOD_ETOOL).getStructure(IDs.MOD_ETOOL, this.props.entity.entity) || {};
        const kraftstoff_distance: Array<any> = [];
        (((structure.ATTS || []).find((item: any) => item.KEY === 'kraftstoff_distance') || {}).OPTS || []).forEach((item: any) =>
            item.TITEL && item.VALUE ? kraftstoff_distance.push({ tid: item.VALUE, name: item.TITEL }) : null
        );
        return kraftstoff_distance;
    }

    getTransportmittel() {
        const row: any = this.props.values || {};
        const structure: any = new StructureTool(IDs.MOD_ETOOL).getStructure(IDs.MOD_ETOOL, this.props.entity.entity) || {};
        let transportmittel: Array<any> = [];
        // WKETOOL-99
        (((structure.ATTS || []).find((item: any) => item.KEY === 'transportmittel_mobilitaet') || {}).OPTS || []).forEach((item: any) =>
            item.TITEL && item.VALUE ? transportmittel.push({ tid: item.VALUE, name: item.TITEL, input_group: item.INPUT_GROUP }) : null
        );
        transportmittel = filterBundleForForm(this.entity, 'transportmittel_mobilitaet', transportmittel, row, this.props.standortSelected);
        transportmittel.sort((a: any, b: any) => {
            if (a.name > b.name) {
                return 1;
            }
            if (a.name < b.name) {
                return -1;
            }
            return 0;
        });
        return transportmittel;
    }

    getValue(value: any): any {
        return typeof value !== 'undefined' && value !== null && !isNaN(+value) ? +value : null;
    }

    isValid(data: any): boolean {
        const hasKraftstoff: boolean = (data.transportmittel_mobilitaet || '').startsWith('pkw_');
        let isValid: boolean = isValidData(
            { entfernung: data.entfernung, kraftstoff_distance: data.kraftstoff_distance, modus: data.modus, transportmittel_mobilitaet: data.transportmittel_mobilitaet },
            this.props.entity.entity,
            this.props.data
        );
        isValid = isValid ? data.transportmittel_mobilitaet === null ? true : (hasKraftstoff && data.kraftstoff_distance !== null) || !hasKraftstoff : false;
        return isValid;
    }

    onChange(data: any): void {
        const index: number = typeof data.index === 'number' ? data.index : null;
        const value: any = data.value || null;
        const name: string = data.name || (this.state.data[index] || null);
        const kraftstoff_distance: any = name === 'transportmittel_mobilitaet' && !!(!(value || '').startsWith('pkw_')) ? { kraftstoff_distance: null } : {};
        const modus: any = value && !value.modus ? { modus: this.props.values.modus } : {};
        const values: any = this.state.data;
        // modus darf nicht fehlen!!! Ansonst ergibt isValid() immer false.
        values[index] = { ...values[index], [name]: value, ...kraftstoff_distance, ...modus };
        this.setState({ data: values });
    }

    reloadData(data: any): void {
        // Speichere Jahresdaten durch onChange
        this.props.onChange(this.entity, data);
        // this.triggerService.fire('reload', this.entity); // doppelter Reload, auskommentiert
        if (typeof this.props.reloadData === 'function') {
            // reloadData ist die Reload-Funktion aus DateneingabeCO2Komplex
            this.props.reloadData(this.entity);
        }
        this.props.onClose();
    }

    render(): JSX.Element {
        if (this.state.data) {
            return (
                <div className={classNames(formStyle.sidebysideComplexGreen, style.wrapper)}>
                    {this.renderText('info_scope3_entfernungen')}
                    {this.renderHeader()}
                    {this.renderEntfernungen()}
                    {this.renderFooter()}
                    {this.state.showSpinner && <WSpinner />}
                </div>
            );
        }
        return null;
    }

    renderHinweis(): JSX.Element {
        const { values } = this.props;
        if (values.hin_rueck === 2 || values.hin_rueck_orig === 2) {
            return <div>Die gesamte Strecke soll über den Teilstreckenrechner erfasst werden.</div>;
        }
        return <div></div>;
    }

    renderButtons(): JSX.Element {
        return (
            <div
                className={style.buttons}
                style={{ width: 150, padding: 0, maxWidth: 'unset' }}
            >
                <WActionButton
                    disabled={this.state.showSpinner}
                    label='Werte speichern und übernehmen'
                    insideText='Werte speichern und übernehmen'
                    styleProps={{ width: 150, marginRight: 20 }}
                    key='save'
                    action='save'
                    onAction={() => this.saveData()}
                />
                {/*<WActionButton
                    label='Schließen'
                    insideText='Schließen'
                    key='close'
                    action='delete'
                    onAction={this.props.onClose}
                />*/}
            </div>
        );
    }

    renderEntfernungen(): Array<JSX.Element> {
        const n: number = Object.keys(this.state.data || {}).length;
        const values: any = this.state.data || {};
        let rows: Array<JSX.Element> = [];
        this.sumEntfernung = null;

        Object.keys(values).forEach((i: string) => {
            const value: any = values[i] || {};
            const entfernung: number = +value.entfernung || 0;
            const isValid: boolean = this.isValid(value);
            this.sumEntfernung = isValid
                ? (value.entfernung !== null ? +this.sumEntfernung + entfernung : this.sumEntfernung)
                : this.sumEntfernung;
            rows.push(
                <React.Fragment key={`row-${i}`}>{this.renderRow(+i)}</React.Fragment>
            );
        });

        if (n) {
            rows.push(
                <React.Fragment key={`row-${n}`}>{this.renderRow(n)}</React.Fragment>
            );
        } else {
            rows = [
                <React.Fragment key={`row-${n}`}>{this.renderRow(n)}</React.Fragment>,
                <React.Fragment key={`row-${n + 1}`}>{this.renderRow(n)}</React.Fragment>
            ];
        }

        return rows;
    }

    renderFooter(): JSX.Element {
        return (
            <div className={style.footer}>
                {this.renderHinweis()}
                <div>Summe</div>
                <div>{fn2nZ(this.sumEntfernung)}</div>
                {this.renderButtons()}
            </div>
        );
    }

    renderHeader(): JSX.Element {
        return (
            <div className={style.header}>
                <div>Transportmittel</div>
                <div>Kraftstoff</div>
                <div>Entfernung [km]</div>
                <div style={{ padding: '2px 0' }}>
                    {this.renderHilfeSymbol()}
                </div>
            </div>
        );
    }

    renderHilfeSymbol(): JSX.Element {
        return (
            <WHelpIcon
                data={this.props.data}
                styleDivProps={{ marginTop: 2, marginLeft: 100 }}
                styleProps={{ margin: 0 }}
                label='Rechner - Entfernung'
                helpKey='dialog_rechner_entfernung'
                style={'theme_small'}
                type={'theme_info'}
                customElement={'Info'}
                editBar
                useTheme
            />
        );
    }

    renderRow(index: number): JSX.Element {
        const values: any = this.state.data[index] || {};
        const kraftstoff: Array<any> = this.FormData.getBundleValues('kraftstoff_distance');
        const transportmittel: Array<any> = this.FormData.getBundleValues('transportmittel_mobilitaet');
        const disabledKraftstoff: boolean = kraftstoff.length < 2 || !!(!(values.transportmittel_mobilitaet || '').startsWith('pkw_'));
        const disabledTransportmittel: boolean = transportmittel.length < 2;
        this.FormData.setAllValues({
            modus: this.getValue(values.modus) || (this.props.values || {}).modus || null,
            entfernung: this.getValue(values.entfernung),
            kraftstoff_distance: values.kraftstoff_distance || null,
            transportmittel_mobilitaet: values.transportmittel_mobilitaet || null
        });

        return (
            <div className={style.fields}>
                <div>
                    <select
                        name='transportmittel_mobilitaet'
                        value={values.transportmittel_mobilitaet || null}
                        disabled={disabledTransportmittel}
                        onChange={(evt: any) =>
                            this.onChange({ index, name: evt.target.name, value: evt.target.value === '0' ? null : evt.target.value })
                        }
                    >
                        {!transportmittel.length &&
                            <option>Nicht verfügbar</option>
                        }
                        {transportmittel.length > 1 &&
                            <option
                                key='transportmittel-'
                                value={0}
                            >
                                {i18n('keine Auswahl', 'sys')}
                            </option>
                        }
                        {transportmittel.map((item: any, index: number) =>
                            <option
                                key={`transportmittel-${index}`}
                                value={item.tid || undefined}
                            >
                                {item.name || null}
                            </option>
                        )}
                    </select>
                    {this.renderValidation('transportmittel_mobilitaet')}
                </div>
                <div>
                    {!disabledKraftstoff &&
                        <>
                            <select
                                name='kraftstoff_distance'
                                value={values.kraftstoff_distance || null}
                                disabled={disabledKraftstoff}
                                onChange={(evt: any) =>
                                    this.onChange(
                                        { index, name: evt.target.name, value: evt.target.value === '0' ? null : evt.target.value }
                                    )
                                }
                            >
                                {!kraftstoff.length &&
                                    <option>Nicht verfügbar</option>
                                }
                                {kraftstoff.length > 1 &&
                                    <option
                                        key='kraftstoff-'
                                        value={0}
                                    >
                                        {i18n('keine Auswahl', 'sys')}
                                    </option>
                                }
                                {kraftstoff.map((item: any, index: number) =>
                                    <option
                                        key={`kraftstoff-${index}`}
                                        value={item.tid || undefined}
                                    >
                                        {item.name || null}
                                    </option>
                                )}
                            </select>
                            {this.renderValidation('kraftstoff_distance')}
                        </>
                    }
                </div>
                <div>
                    <input
                        name='entfernung'
                        type='number'
                        value={values.entfernung || (values.entfernung === 0 ? 0 : null)}
                        required
                        onChange={(evt: any) => {
                            this.onChange({ index, name: evt.target.name, value: evt.target.value });
                        }}
                    />
                    {this.renderValidation('entfernung')}
                </div>
                {/* <div>
                    <WFormFieldArchiv
                        entity={this.entity}
                        label={null}
                        name='datei'
                        value={values.datei || 0}
                        data={values}
                        onValueChange={(name: string, value: any) => {
                            this.onChange({ index, name, value });
                        }}
                        module={IDs.MOD_ETOOL}
                        layout='noneAutoSave'
                    />
                </div> */}
                <div></div>
            </div>
        );
    }

    renderText(titel: string): JSX.Element | JSX.Element[] {
        const beschreibung: any = renderText(titel, this.props.data);

        return beschreibung && this.entity === IDs.ENT_CO2_SCOPE3_REISEN
            ? <div className={style.text}>{beschreibung}</div>
            : null;
    }

    renderValidation(key: string): JSX.Element {
        const { text, type } = this.validateField(key);

        if (!text) {
            return null;
        }

        return (
            <div
                className={formStyle.warnSignDlgRechner}
                style={{ ...(type === 'warning' && { color: '#616468' }) }}
                title={text}
            >
                *
            </div>
        );
    }

    saveData(): void {
        const delList: Array<any> = [];
        const entityData: Array<any> = this.props.data[this.entity] || [];
        const row: any = this.props.values || {};
        const parent_tid = row.tid || 0;
        const saveList: Array<any> = [];
        const values: any = this.state.data || {};
        const data = entityData.filter((r: any) => r.parent_tid === parent_tid && r.modus === row.modus);
        let sumEntfernung: number = null;

        // WKETOOL-191: Wenn es eine Eingabe ohne gewählten Krafstoff gibt, dann das Speichern abbrechen.
        const invalidRows = Object.keys(values)
            .filter((i: string) => (values[i].transportmittel_mobilitaet || '').startsWith('pkw_') && values[i].entfernung > 0 && !values[i].kraftstoff_distance)
            .map((i: string) => values[i]);
        if (invalidRows.length > 0) {
            console.log(invalidRows);
            alert('Bitte Kraftstoff(e) wählen!');
            return;
        }

        Object.keys(values).forEach((i: string) => {
            const value: any = values[i] || {};
            const datei = +value.datei || 0;
            const datei_archiv_delete = value.datei_archiv_delete || 0;
            const datei_archiv_filename = value.datei_archiv_filename || null;
            const datei_archiv_rawdata = value.datei_archiv_rawdata || null;
            const entfernung: number = +value.entfernung || 0;
            const kraftstoff_distance: string = value.kraftstoff_distance || null;
            const tid: number = +value.tid || null;
            const transportmittel_mobilitaet: string = value.transportmittel_mobilitaet || null;
            const modus: string = row.modus || null;
            const art: string = row.art || null;
            const found = data.find((item: any) => item.tid === (value.tid || null));
            const isValid: boolean = this.isValid(value);
            sumEntfernung = isValid ? (value.entfernung !== null ? +sumEntfernung + entfernung : sumEntfernung) : sumEntfernung;

            if (found) { // Wenn Datensatz schon vorhanden --> immer speichern
                if (value.entfernung === null && !datei && !datei_archiv_rawdata) {
                    delList.push({ tid });
                } else {
                    saveList.push({
                        datei,
                        ...(datei_archiv_delete ? { datei_archiv_delete } : {}),
                        ...(datei_archiv_filename ? { datei_archiv_filename } : {}),
                        ...(datei_archiv_rawdata ? { datei_archiv_rawdata } : {}),
                        entfernung: this.getValue(value.entfernung),
                        tid,
                        kraftstoff_distance,
                        transportmittel: null,
                        transportmittel_mobilitaet,
                        modus,
                        art
                    });
                }
            } else if (entfernung > 0 || datei > 0 || datei_archiv_rawdata) {
                saveList.push({
                    datei,
                    ...(datei_archiv_delete ? { datei_archiv_delete } : {}),
                    ...(datei_archiv_filename ? { datei_archiv_filename } : {}),
                    ...(datei_archiv_rawdata ? { datei_archiv_rawdata } : {}),
                    ...(this.getValue(value.entfernung) !== null ? { entfernung } : {}),
                    jahr: this.props.jahr,
                    parent_tid,
                    standort_tid: this.props.standortSelected.tid,
                    kraftstoff_distance,
                    transportmittel: null,
                    transportmittel_mobilitaet,
                    modus,
                    art
                });
            }
        });
        const valueYear: any = entityData.find((item: any) => item.tid === row.tid);

        Object.keys(this.FormData.bundle || {}).forEach((key: string) =>
            delete valueYear[key]
        );
        sumEntfernung = sumEntfernung !== null ? Math.round(sumEntfernung * 100) / 100 : null;
        valueYear._formKey = row._formKey;
        valueYear.entfernung = sumEntfernung;
        valueYear.standort_tid = this.props.standortSelected.tid;
        valueYear.kraftstoff_distance = null;
        valueYear.transportmittel = null;
        valueYear.transportmittel_mobilitaet = null;

        if (saveList.length > 0) {
            // Speichere Daten durch dataService.saveDataList
            this.setState({ showSpinner: true }, () => {
                this.dataService.saveDataList(this.entity, saveList, (sql: string, success: boolean) => {
                    this.setState({ showSpinner: false });
                    if (valueYear) { // Wenn Datensatz schon vorhanden --> immer speichern
                        delList.length
                            ? this.dataService.delDataList(this.entity, delList, () => this.reloadData(valueYear))
                            : this.reloadData(valueYear);
                    } else if (sumEntfernung > 0) {
                        this.reloadData({
                            _formKey: row._formKey,
                            entfernung: sumEntfernung,
                            jahr: this.props.jahr,
                            standort_tid: this.props.standortSelected.tid
                        });
                    } else {
                        this.props.onClose();
                    }
                }, IDs.MOD_ETOOL);
            });
        } else if (delList.length > 0) {
            this.dataService.delDataList(this.entity, delList, () => this.reloadData(valueYear));
        } else {
            this.props.onClose();
        }
    }

    validateField(key: string): { text: string, type: string } {
        const name: string = (key || '').length
            ? (key || '').replace(/^\w/, (name: string) => name.toUpperCase())
            : null;
        const transportmittel: string = this.FormData.getValue('transportmittel_mobilitaet');
        const value: number | string = this.FormData.getValue(key);
        let text: string = null;
        let type: string = null;

        if (value === null && transportmittel !== null) {
            text = `Bitte Feld "${name}" ausfüllen`;
            type = 'error';
        } else {
            text = removeErrorLevelAddOn(
                validateFieldUniversal(
                    this.props.entity.entity, key, value, this.FormData, null, this.props.data,
                    (data: any) => type = (data || {}).type || null
                )
            );
        }

        return { text, type };
    }
}
